import React from 'react';
import PropTypes from 'prop-types';

import { packageRoute } from '@util/routes';

import PackageCard from '@components/navigator/PackageCard';

import * as styles from './PackageList.module.css';

const isExactMatch = (searchTerm, name) => {
  if (!searchTerm || searchTerm === '') return false;
  return searchTerm.toLowerCase() === name.toLowerCase();
};

const PackageList = ({ packages = [], title, className, searchTerm }) => {
  return (
    <div className={className}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <div className={styles.list}>
        {packages.map((pkg) => (
          <PackageCard
            key={pkg.name}
            name={pkg.name}
            isExactMatch={isExactMatch(searchTerm, pkg.name)}
            href={packageRoute(pkg.registry, pkg.name)}
            registry={pkg.registry}
            keywords={pkg.latestVersion.keywords}
            description={pkg.description}
            contributors={pkg.contributorsTotal}
            scores={pkg.scores}
            latestVersion={pkg.latestVersion.version}
            licenses={pkg.latestVersion.licenses}
            lastReleaseDate={pkg.latestVersion.released}
            vulnerabilities={pkg.currentVulnerabilities}
          />
        ))}
      </div>
    </div>
  );
};

PackageList.propTypes = {
  packages: PropTypes.array,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  searchTerm: PropTypes.string,
  className: PropTypes.string,
};

export default PackageList;
